import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FleetDataItem } from '../../types/FleetDataItem';
import { ShipParticulars } from '../../types/Paraticulars';

export interface VesselViewState {
    selectedVessel: FleetDataItem | undefined;
    vesselViewOpen: boolean
    vesselParticulars: ShipParticulars | undefined;
    vesselParticularsLoading: boolean;
    vesselParticularsError: boolean;
    vesselImage: string;
    vesselImageLoading: boolean;
    vesselImageError: boolean;
    vesselGradeImage: string;
    vesselGradeImageLoading: boolean;
    vesselGradeImageError: boolean;
}

export const initialState: VesselViewState = {
    selectedVessel: undefined,
    vesselViewOpen: false,
    vesselParticulars: undefined,
    vesselParticularsLoading: false,
    vesselParticularsError: false,
    vesselImage: "",
    vesselImageLoading: false,
    vesselImageError: false,
    vesselGradeImage: "",
    vesselGradeImageLoading: false,
    vesselGradeImageError: false,
};

export const vesselViewSlice = createSlice({
    name: 'vesselView',
    initialState,
    reducers: {
        setSelectedVessel: (state, action: PayloadAction<FleetDataItem | undefined>) => {
            state.selectedVessel = action.payload;
        },
        setVesselViewOpen: (state, action: PayloadAction<boolean>) => {
            state.vesselViewOpen = action.payload;
        },
        setVesselParticulars: (state, action: PayloadAction<ShipParticulars | undefined>) => {
            state.vesselParticulars = action.payload;
        },
        setVesselParticularsLoading: (state, action: PayloadAction<boolean>) => {
            state.vesselParticularsLoading = action.payload;
        },
        setVesselParticularsError: (state, action: PayloadAction<boolean>) => {
            state.vesselParticularsError = action.payload;
        },
        setVesselImage: (state, action: PayloadAction<string>) => {
            state.vesselImage = action.payload;
        },
        setVesselImageLoading: (state, action: PayloadAction<boolean>) => {
            state.vesselImageLoading = action.payload;
        },
        setVesselImageError: (state, action: PayloadAction<boolean>) => {
            state.vesselImageError = action.payload;
        },
        setVesselGradeImage: (state, action: PayloadAction<string>) => {
            state.vesselGradeImage = action.payload;
        },
        setVesselGradeImageLoading: (state, action: PayloadAction<boolean>) => {
            state.vesselGradeImageLoading = action.payload;
        },
        setVesselGradeImageError: (state, action: PayloadAction<boolean>) => {
            state.vesselGradeImageError = action.payload;
        },
    },
});

export const { 
    setSelectedVessel,
    setVesselViewOpen,
    setVesselParticulars,
    setVesselParticularsLoading,
    setVesselParticularsError,
    setVesselImage,
    setVesselImageLoading,
    setVesselImageError,
    setVesselGradeImage,
    setVesselGradeImageLoading,
    setVesselGradeImageError,
} = vesselViewSlice.actions;

export default vesselViewSlice.reducer;
